import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";

export default function ReplyWall() {
  const replies = posts.filter((post) => post.category === "shenhuifu").slice(0, 6);

  return (
    <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {replies.map((post, index) => (
        <li key={post.id}>
          <Link
            to={`/post/${post.id}`}
            className="group h-full flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/80 hover:border-accent-400 transition-colors cursor-pointer"
          >
            <span
              className={`w-9 h-9 rounded-md flex items-center justify-center text-lg ${
                index % 2 === 0 ? "bg-accent-100 text-accent-800" : "bg-secondary-100 text-secondary-800"
              }`}
            >
              <i className="ri-double-quotes-l"></i>
            </span>
            <h3 className="mt-4 text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
              {post.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">{post.excerpt}</p>
            <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-400">
              <span className="whitespace-nowrap">{post.author}</span>
              <span className="flex items-center gap-1">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-heart-3-line"></i>
                </span>
                {post.likes}
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}